/* [vrsn] product page: clearer out-of-stock state (Oct 2026).
   Switched by Theme settings > Cart > Pre-order / Notify System > "Out-of-stock style".
   - classic   : nothing here runs (theme default: pre-order sizes crossed out).
   - clear     : pre-order sizes greyed instead of crossed out + a stock status line under the size picker.
   - clear_bar : the above + a buy bar pinned to the bottom of the screen while the main button is out of view.
   - clear_bar_desktop : same as clear_bar, but no pinned bar on phones (up to 749px).
   The bar presses the page's own Add to cart / Pre-order button, so the normal flow (insole offer, cart) is unchanged.
   Tapping the bar's text opens an options sheet (colour, Women / Men, size). The sheet presses the page's
   own controls too, so stock, prices and pre-order handling stay with the theme.
   Config comes from snippets/modal-notify-me.liquid (script[data-vrsn-pdp-config]).
   vrsn-batch v1 (2026-10-22): on a batch product (Theme settings > Batch system) snippets/vrsn-batch.liquid sets
   window.vrsnBatch[sectionId]; the bar then shows the size as picked (W8.5, M8, EU 40), a shoe photo and a thin
   batch strip, and pre-order sizes read "Next batch · Ships Nov 30". Without it nothing below changes.
   v2 (22 Oct): the strip is one joined bar, earlier batches black, the open batch striped lime. */
(function () {
  if (window.__vrsnPdp) return;
  window.__vrsnPdp = true;

  function cfgText(value, fallback) {
    return value == null || value === '' ? fallback : String(value);
  }

  function esc(value) {
    var d = document.createElement('div');
    d.textContent = value == null ? '' : String(value);
    return d.innerHTML;
  }

  function isShown(el) {
    return !!(el && el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden');
  }

  // The words a shopper sees on one of the theme's option buttons ("White", "8.5").
  function labelText(radio) {
    var label = radio.labels && radio.labels[0];
    if (!label) return radio.value;
    var hiddenName = label.querySelector('.sr-only');
    if (hiddenName && hiddenName.textContent.trim()) return hiddenName.textContent.trim();
    var text = '';
    Array.prototype.forEach.call(label.childNodes, function (node) {
      if (node.nodeType === 3) text += node.textContent;
    });
    return text.trim() || radio.value;
  }

  function Pdp(cfg) {
    this.cfg = cfg;
    this.wrap = document.getElementById('MainProduct-' + cfg.sectionId) || document;
    this.picker = this.wrap.querySelector('variant-selects');
    this.mainBtn = document.getElementById('ProductSubmitButton-' + cfg.sectionId);
    this.optionIndexCache = {};
    this.batch = (window.vrsnBatch && window.vrsnBatch[cfg.sectionId]) || null;
    this.update = this.update.bind(this);
    if (!this.picker) return;

    this.picker.classList.add('vrsn-clear');
    if (cfg.bar && this.mainBtn) this.initBar();

    var self = this;
    document.addEventListener('change', function (evt) {
      if (self.picker.contains(evt.target)) requestAnimationFrame(self.update);
    });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, function () { self.update(); });
    }
    this.update();
    // The size picker finishes setting itself up after load.
    setTimeout(this.update, 400);
    setTimeout(this.update, 1500);
  }

  Pdp.prototype.variants = function () {
    if (Array.isArray(this.picker.variantData)) return this.picker.variantData;
    if (!this._variants) {
      try {
        var nodes = this.picker.querySelectorAll('script[type="application/json"]');
        this._variants = JSON.parse(nodes[nodes.length - 1].textContent);
      } catch (e) {
        this._variants = [];
      }
    }
    return this._variants;
  };

  Pdp.prototype.current = function () {
    if (this.picker.currentVariant) return this.picker.currentVariant;
    var input = document.querySelector('#product-form-' + this.cfg.sectionId + '-' + this.cfg.productId + ' [name="id"]');
    var id = input ? String(input.value) : '';
    return this.variants().find(function (v) { return String(v.id) === id; }) || null;
  };

  // The theme lists which variants are being oversold (pre-order) in a hidden select.
  Pdp.prototype.isPre = function (variantId) {
    var select = document.getElementById('select-option-' + this.cfg.productId);
    if (!select) return false;
    var option = select.querySelector('option[value="' + variantId + '"]');
    return !!option && option.dataset.outOfStock === 'true';
  };

  Pdp.prototype.sizeFieldset = function () {
    return this.picker.querySelector('fieldset.product-form__input:not(.product-form__input--color):not(.product-form__input--swatch)');
  };

  Pdp.prototype.optionIndex = function (value) {
    if (!(value in this.optionIndexCache)) {
      var found = -1;
      this.variants().some(function (v) {
        var i = v.options.indexOf(value);
        if (i > -1) { found = i; return true; }
        return false;
      });
      this.optionIndexCache[value] = found;
    }
    return this.optionIndexCache[value];
  };

  Pdp.prototype.markSizes = function (cur) {
    var fieldset = this.sizeFieldset();
    if (!fieldset || !cur) return;
    var self = this;
    var variants = this.variants();
    fieldset.querySelectorAll('input[type="radio"]').forEach(function (radio) {
      var idx = self.optionIndex(radio.value);
      var candidate = idx < 0 ? null : variants.find(function (v) {
        return v.options.every(function (o, i) { return i === idx ? o === radio.value : o === cur.options[i]; });
      });
      radio.classList.toggle('vrsn-pre', !!(candidate && candidate.available && self.isPre(candidate.id)));
    });
  };

  Pdp.prototype.statusFor = function (cur) {
    if (!cur || !cur.available) return { state: 'out', text: this.cfg.soldoutText };
    if (this.isPre(cur.id)) return { state: 'pre', text: (this.batch && this.batch.status) || this.cfg.preorderText };
    return { state: 'in', text: this.cfg.instockText };
  };

  Pdp.prototype.notifyOpener = function () {
    var box = document.getElementById('notify-me-message-' + this.cfg.sectionId);
    return box ? box.querySelector('modal-opener button') : null;
  };

  Pdp.prototype.renderStatus = function (status) {
    var host = this.sizeFieldset() || this.picker;
    var row = host.querySelector('.vrsn-size-status');
    var self = this;
    if (!row) {
      row = document.createElement('div');
      row.className = 'vrsn-size-status';
      row.setAttribute('role', 'status');
      row.setAttribute('aria-live', 'polite');
      row.innerHTML = '<span class="vrsn-size-status__text"><i aria-hidden="true"></i><span></span></span>' +
        '<button type="button" class="vrsn-size-status__link"></button>';
      row.querySelector('button').addEventListener('click', function () {
        var opener = self.notifyOpener();
        if (opener) opener.click();
      });
      host.appendChild(row);
    }
    var text = String(status.text || '');
    var parts = text.split('·');
    row.dataset.state = status.state;
    row.querySelector('.vrsn-size-status__text span').innerHTML = parts.length > 1
      ? '<b>' + esc(parts[0].trim()) + '</b> · ' + esc(parts.slice(1).join('·').trim())
      : '<b>' + esc(text) + '</b>';
    var opener = this.notifyOpener();
    var link = row.querySelector('button');
    link.textContent = opener ? opener.textContent.trim() : '';
    link.hidden = !(status.state === 'pre' && opener && link.textContent);
    row.hidden = !text;
  };

  Pdp.prototype.priceText = function () {
    var nodes = this.wrap.querySelectorAll('[id="price-' + this.cfg.sectionId + '"] .price__sale .price-item--sale, [id="price-' + this.cfg.sectionId + '"] .price__regular .price-item--regular');
    for (var i = 0; i < nodes.length; i++) {
      if (isShown(nodes[i]) && nodes[i].textContent.trim()) return nodes[i].textContent.trim();
    }
    return '';
  };

  Pdp.prototype.initBar = function () {
    var self = this;
    var bar = document.createElement('div');
    bar.className = 'vrsn-bar' + (this.cfg.barPhones === false ? ' vrsn-bar--no-phone' : '');
    bar.innerHTML = '<button type="button" class="vrsn-bar__info" aria-haspopup="dialog">' +
      '<span class="vrsn-bar__line"><span class="vrsn-bar__variant"></span><i class="vrsn-bar__caret" aria-hidden="true"></i></span>' +
      '<span class="vrsn-bar__status"></span></button>' +
      '<button type="button" class="vrsn-bar__btn"></button>';
    if (this.batch) {
      bar.classList.add('vrsn-bar--batch');
      if (this.batch.thumb) bar.insertAdjacentHTML('afterbegin', '<img class="vrsn-bar__thumb" alt="" hidden>');
      if (this.batch.strip) {
        // One joined strip: earlier batches in black, then the open batch striped lime, filled by pairs already ordered.
        var soldPct = Math.round((Number(this.batch.n) - 1) * 100 / Number(this.batch.n));
        bar.insertAdjacentHTML('afterbegin', '<span class="vrsn-bar__strip" aria-hidden="true" hidden>' +
          '<span class="vrsn-bar__strip-sold" style="width:' + soldPct + '%"></span>' +
          '<span class="vrsn-bar__strip-now"><i style="width:' + Number(this.batch.fill) + '%"></i></span></span>');
      }
    }
    document.body.appendChild(bar);
    this.bar = bar;
    this.barInfo = bar.querySelector('.vrsn-bar__info');
    this.barInfo.setAttribute('aria-label', cfgText(this.cfg.changeLabel, 'Change colour or size'));
    this.barInfo.addEventListener('click', function () { self.openSheet(); });
    this.barBtn = bar.querySelector('.vrsn-bar__btn');
    this.barBtn.addEventListener('click', function () { self.mainBtn.click(); });

    var seen = { main: true, footer: false };
    // The floating currency switcher sits in the same corner; lift it clear of the bar while the bar shows.
    // Uses a margin, not a transform: a transform would trap the switcher's full-screen country list inside it.
    var switcher = document.querySelector('.floating-switcher');
    if (switcher) switcher.style.transition = 'margin-bottom 0.25s ease';
    var apply = function () {
      var on = !seen.main && !seen.footer;
      bar.classList.toggle('is-visible', on);
      if (switcher) switcher.style.marginBottom = on && bar.offsetHeight ? bar.offsetHeight + 'px' : '';
    };
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) { seen.main = entries[entries.length - 1].isIntersecting; apply(); }).observe(this.mainBtn);
      var footer = document.querySelector('footer');
      if (footer) new IntersectionObserver(function (entries) { seen.footer = entries[entries.length - 1].isIntersecting; apply(); }).observe(footer);
    }
    // The theme rewrites the main button (label, disabled) after each variant change; mirror it.
    new MutationObserver(function () { self.renderBar(); self.renderSheet(); }).observe(this.mainBtn, { attributes: true, childList: true, subtree: true, characterData: true });
    // If the theme's own pinned bar is also switched on, keep only this one.
    document.querySelectorAll('product-add-to-cart-sticky').forEach(function (el) { el.style.display = 'none'; });
  };

  Pdp.prototype.renderBar = function () {
    if (!this.bar) return;
    var cur = this.current();
    var status = this.statusFor(cur);
    var labelNode = this.mainBtn.querySelector('span');
    var label = (labelNode && labelNode.textContent.trim()) || this.mainBtn.textContent.trim();
    this.barBtn.textContent = label;
    this.barBtn.disabled = this.mainBtn.disabled || this.mainBtn.getAttribute('aria-disabled') === 'true';
    var price = this.priceText();
    if (this.batch) { this.renderBatchBar(cur, status, price); return; }
    var name = cur ? cur.options.join(' · ') : '';
    this.bar.querySelector('.vrsn-bar__variant').textContent = name + (name && price ? ' · ' : '') + price;
    this.bar.querySelector('.vrsn-bar__status').textContent = status.text || '';
  };

  // Batch products: "All Black · W8.5" / "$78.00 · Ships Nov 30", the colour's photo, and the batch strip on pre-order sizes.
  Pdp.prototype.renderBatchBar = function (cur, status, price) {
    var b = this.batch;
    var colour = cur && b.colorIndex > -1 ? cur.options[b.colorIndex] : '';
    var name = cur ? cur.options.join(' · ') : '';
    var line2 = status.text || '';
    if (b.size && cur) {
      name = [colour, this.pickedSize(cur)].filter(Boolean).join(' · ');
      var short = status.state === 'pre' ? b.bar : String(status.text || '').split('·')[0].trim();
      line2 = [price, short].filter(Boolean).join(' · ');
    } else if (price) {
      name += (name ? ' · ' : '') + price;
    }
    this.bar.querySelector('.vrsn-bar__variant').textContent = name;
    this.bar.querySelector('.vrsn-bar__status').textContent = line2;

    var thumb = this.bar.querySelector('.vrsn-bar__thumb');
    if (thumb) {
      var on = this.colorFieldset() && this.colorFieldset().querySelector('input[type="radio"]:checked');
      var img = on && on.labels && on.labels[0] ? on.labels[0].querySelector('img') : null;
      var src = img ? (img.currentSrc || img.src) : '';
      if (src && thumb.getAttribute('src') !== src) thumb.setAttribute('src', src);
      thumb.hidden = !src;
    }
    var strip = this.bar.querySelector('.vrsn-bar__strip');
    if (strip) strip.hidden = status.state !== 'pre';
  };

  // The size as the shopper picked it: Women US 8.5 -> "W8.5", Men -> "M8", EU / UK tabs -> "EU 40" / "UK 6.5".
  Pdp.prototype.pickedSize = function (cur) {
    var fieldset = this.sizeFieldset();
    if (!fieldset) return '';
    var value = cur.options.filter(function (o) {
      return !!fieldset.querySelector('input[type="radio"][value="' + (window.CSS && CSS.escape ? CSS.escape(o) : o) + '"]');
    })[0];
    if (!value) return '';
    var panel = Array.prototype.filter.call(fieldset.querySelectorAll('[data-vsd-panel]'), function (p) { return isShown(p); })[0];
    if (!panel) return value;
    var radio = panel.querySelector('input[type="radio"][value="' + (window.CSS && CSS.escape ? CSS.escape(value) : value) + '"]');
    // The label's own text: sold-out sizes also carry a hidden "sold out" line, so labelText() is not used here.
    var own = radio && radio.labels && radio.labels[0] ? Array.prototype.filter.call(radio.labels[0].childNodes, function (n) {
      return n.nodeType === 3;
    }).map(function (n) { return n.textContent; }).join('').trim() : '';
    var label = own || value;
    var system = panel.getAttribute('data-vsd-panel-system') || 'US';
    var gender = panel.getAttribute('data-vsd-panel-gender');
    if (system !== 'US') return system + ' ' + label;
    if (gender === 'women') return 'W' + label;
    if (gender === 'men') return 'M' + label;
    return 'US ' + label;
  };

  // ---- Options sheet, opened from the pinned bar ----

  Pdp.prototype.colorFieldset = function () {
    return this.picker.querySelector('fieldset.product-form__input--color, fieldset.product-form__input--swatch');
  };

  Pdp.prototype.shownRadios = function (fieldset) {
    if (!fieldset) return [];
    return Array.prototype.filter.call(fieldset.querySelectorAll('input[type="radio"]'), function (radio) {
      return radio.labels && radio.labels[0] && isShown(radio.labels[0]);
    });
  };

  Pdp.prototype.initSheet = function () {
    var self = this;
    var sheet = document.createElement('div');
    sheet.className = 'vrsn-sheet';
    sheet.hidden = true;
    sheet.innerHTML = '<div class="vrsn-sheet__overlay" data-vrsn-close></div>' +
      '<div class="vrsn-sheet__panel" role="dialog" aria-modal="true" tabindex="-1">' +
      '<div class="vrsn-sheet__head"><span class="vrsn-sheet__title"></span>' +
      '<button type="button" class="vrsn-sheet__currency" data-vrsn-currency hidden></button>' +
      '<button type="button" class="vrsn-sheet__close" data-vrsn-close aria-label="Close">&times;</button></div>' +
      '<div class="vrsn-sheet__body"></div>' +
      '<div class="vrsn-sheet__status"><i aria-hidden="true"></i><span></span>' +
      '<button type="button" class="vrsn-sheet__notify" data-vrsn-notify></button></div>' +
      '<button type="button" class="vrsn-sheet__btn"></button></div>';
    document.body.appendChild(sheet);
    this.sheet = sheet;
    this.sheetTargets = [];
    var title = cfgText(this.cfg.sheetTitle, 'Choose your options');
    sheet.querySelector('.vrsn-sheet__title').textContent = title;
    sheet.querySelector('.vrsn-sheet__panel').setAttribute('aria-label', title);

    sheet.addEventListener('click', function (evt) {
      var hit = evt.target.closest('[data-vrsn-close], [data-vrsn-pick], [data-vrsn-notify], [data-vrsn-currency], .vrsn-sheet__btn');
      if (!hit) return;
      if (hit.hasAttribute('data-vrsn-close')) { self.closeSheet(); return; }
      if (hit.hasAttribute('data-vrsn-currency')) {
        // Hand over to the page's own country / currency list (the floating selector's).
        var currencyOpener = self.currencyOpener();
        self.closeSheet(true);
        if (currencyOpener) setTimeout(function () { currencyOpener.click(); }, 60);
        return;
      }
      if (hit.hasAttribute('data-vrsn-notify')) {
        // Hand over to the page's own Notify me popup; it already follows the selected size.
        var opener = self.notifyOpener();
        self.closeSheet(true);
        if (opener) setTimeout(function () { opener.click(); }, 60);
        return;
      }
      if (hit.classList.contains('vrsn-sheet__btn')) {
        self.closeSheet();
        self.mainBtn.click();
        return;
      }
      var target = self.sheetTargets[Number(hit.getAttribute('data-vrsn-pick'))];
      if (target) target.click();
      // The theme redraws its picker after a choice; follow it.
      setTimeout(self.update, 60);
      setTimeout(self.update, 400);
      setTimeout(self.update, 1200);
    });
    document.addEventListener('keydown', function (evt) {
      if (evt.key === 'Escape' && !sheet.hidden) self.closeSheet();
    });
  };

  Pdp.prototype.openSheet = function () {
    if (!this.sheet) this.initSheet();
    var sheet = this.sheet;
    clearTimeout(this.sheetTimer);
    sheet.hidden = false;
    document.documentElement.classList.add('vrsn-sheet-open');
    this.renderCurrency();
    this.renderSheet();
    this.sheetTimer = setTimeout(function () {
      sheet.classList.add('is-open');
      sheet.querySelector('.vrsn-sheet__panel').focus({ preventScroll: true });
    }, 20);
  };

  // The floating country / currency selector's button, when the page has one.
  Pdp.prototype.currencyOpener = function () {
    return document.querySelector('.floating-switcher .disclosure__button');
  };

  // Mirrors that selector (flag + currency) as a small chip beside the panel title.
  Pdp.prototype.renderCurrency = function () {
    var chip = this.sheet && this.sheet.querySelector('.vrsn-sheet__currency');
    if (!chip) return;
    var opener = this.currencyOpener();
    if (!opener) { chip.hidden = true; return; }
    var flag = opener.querySelector('img');
    var text = opener.textContent.replace(/\s+/g, ' ').trim();
    chip.innerHTML = (flag ? '<img src="' + esc(flag.currentSrc || flag.src) + '" alt="">' : '') +
      '<span>' + esc(text) + '</span><i aria-hidden="true"></i>';
    chip.setAttribute('aria-label', cfgText(this.cfg.currencyLabel, 'Change country or currency') + (text ? ': ' + text : ''));
    chip.hidden = !(flag || text);
  };

  // keepFocus: another popup is about to open, so do not pull focus back to the bar.
  Pdp.prototype.closeSheet = function (keepFocus) {
    var sheet = this.sheet;
    if (!sheet || sheet.hidden) return;
    var self = this;
    clearTimeout(this.sheetTimer);
    sheet.classList.remove('is-open');
    document.documentElement.classList.remove('vrsn-sheet-open');
    this.sheetTimer = setTimeout(function () {
      sheet.hidden = true;
      if (keepFocus !== true && self.barInfo) self.barInfo.focus({ preventScroll: true });
    }, 220);
  };

  Pdp.prototype.renderSheet = function () {
    var sheet = this.sheet;
    if (!sheet || sheet.hidden) return;
    var self = this;
    var targets = [];
    var pick = function (el) { targets.push(el); return targets.length - 1; };
    var html = '';
    var cur = this.current();
    // "Selected" follows the variant actually chosen, not each button's own tick: the theme keeps a
    // separate set of size buttons per Women / Men and US / EU / UK view and does not keep them in step.
    // If nothing in a group is ticked yet (a product that opens with no size chosen), nothing is selected.
    var isOn = function (radio, fieldset) {
      if (!fieldset.querySelector('input[type="radio"]:checked')) return false;
      return cur && cur.options ? cur.options.indexOf(radio.value) !== -1 : radio.checked;
    };

    var colorFieldset = this.colorFieldset();
    var colors = this.shownRadios(colorFieldset);
    if (colors.length) {
      var chosen = colors.filter(function (radio) { return isOn(radio, colorFieldset); })[0];
      html += '<div class="vrsn-sheet__group"><div class="vrsn-sheet__label"><span>' + esc(cfgText(this.cfg.colorLabel, 'Color')) +
        (chosen ? ': <b>' + esc(labelText(chosen)) + '</b>' : '') + '</span></div><div class="vrsn-sheet__swatches">';
      colors.forEach(function (radio) {
        var img = radio.labels[0].querySelector('img');
        var src = img ? (img.currentSrc || img.src) : '';
        var colorOn = isOn(radio, colorFieldset);
        html += '<button type="button" class="vrsn-sheet__swatch' + (colorOn ? ' is-on' : '') + '" data-vrsn-pick="' + pick(radio.labels[0]) +
          '" aria-pressed="' + colorOn + '" aria-label="' + esc(labelText(radio)) + '">' +
          (src ? '<img src="' + esc(src) + '" alt="">' : '<span>' + esc(labelText(radio)) + '</span>') + '</button>';
      });
      html += '</div></div>';
    }

    var sizeFieldset = this.sizeFieldset();
    var sizes = this.shownRadios(sizeFieldset);
    if (sizes.length) {
      var segments = function (nodes) {
        var out = '';
        Array.prototype.forEach.call(nodes, function (node) {
          if (!isShown(node)) return;
          var on = node.classList.contains('active');
          out += '<button type="button" class="vrsn-sheet__seg' + (on ? ' is-on' : '') + '" data-vrsn-pick="' + pick(node) +
            '" aria-pressed="' + on + '">' + esc(node.textContent.trim()) + '</button>';
        });
        return out ? '<span class="vrsn-sheet__segs">' + out + '</span>' : '';
      };
      html += '<div class="vrsn-sheet__group"><div class="vrsn-sheet__label"><span>' + esc(cfgText(this.cfg.sizeLabel, 'Size')) + '</span>' +
        segments(sizeFieldset.querySelectorAll('.vsd-system-btn')) + '</div>' +
        segments(this.wrap.querySelectorAll('.custom_radio .gender-select')).replace('vrsn-sheet__segs', 'vrsn-sheet__segs vrsn-sheet__segs--wide') +
        '<div class="vrsn-sheet__sizes">';
      sizes.forEach(function (radio) {
        var pre = radio.classList.contains('vrsn-pre');
        var out = radio.classList.contains('disabled') && !pre;
        var sizeOn = isOn(radio, sizeFieldset);
        html += '<button type="button" class="vrsn-sheet__size' + (sizeOn ? ' is-on' : '') + (pre ? ' is-pre' : '') + (out ? ' is-out' : '') +
          '" data-vrsn-pick="' + pick(radio.labels[0]) + '" aria-pressed="' + sizeOn + '">' + esc(labelText(radio)) + '</button>';
      });
      html += '</div></div>';
    }

    this.sheetTargets = targets;
    sheet.querySelector('.vrsn-sheet__body').innerHTML = html;

    var status = this.statusFor(this.current());
    var statusRow = sheet.querySelector('.vrsn-sheet__status');
    statusRow.dataset.state = status.state;
    statusRow.querySelector('span').textContent = status.text || '';
    statusRow.hidden = !status.text;
    // Pre-order or sold-out size: offer the same "Notify me" as the line under the size buttons.
    var notifyOpener = this.notifyOpener();
    var notifyBtn = sheet.querySelector('.vrsn-sheet__notify');
    notifyBtn.textContent = notifyOpener ? notifyOpener.textContent.trim() : '';
    notifyBtn.hidden = !(notifyOpener && notifyBtn.textContent && (status.state === 'pre' || status.state === 'out'));

    var labelNode = this.mainBtn.querySelector('span');
    var label = (labelNode && labelNode.textContent.trim()) || this.mainBtn.textContent.trim();
    var price = this.priceText();
    var button = sheet.querySelector('.vrsn-sheet__btn');
    button.textContent = label + (price ? ' · ' + price : '');
    button.disabled = this.mainBtn.disabled || this.mainBtn.getAttribute('aria-disabled') === 'true';
  };

  Pdp.prototype.update = function () {
    var cur = this.current();
    this.markSizes(cur);
    this.renderStatus(this.statusFor(cur));
    this.renderBar();
    this.renderSheet();
  };

  function boot() {
    document.querySelectorAll('script[data-vrsn-pdp-config]').forEach(function (node) {
      if (node.dataset.vrsnBooted) return;
      node.dataset.vrsnBooted = 'true';
      try {
        var cfg = JSON.parse(node.textContent);
        if (cfg && cfg.style && cfg.style !== 'classic') new Pdp(cfg);
      } catch (e) {
        console.error('[vrsn-pdp] config error', e);
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
